export default {
    //背词list，practiseWordList在这里，根据新词演变而来，实时同步
    practiseWordList(state){
        let practiseWordList=[];
        for(let i=0;i<state.newWordList.length+20;i++){
            if(i<state.newWordList.length){
                practiseWordList.push(state.newWordList[i]);
                if(i>1){
                    practiseWordList.push(state.newWordList[i-2]);
                    if(i>5){
                        practiseWordList.push(state.newWordList[i-6]);
                        if(i>19){
                            practiseWordList.push(state.newWordList[i-20]);
                        }
                    }
                }
            }else {
                if(1<i && i<(state.newWordList.length+2)){
                    practiseWordList.push(state.newWordList[i-2]);
                }
                if(5<i && i<(state.newWordList.length+6)){
                    practiseWordList.push(state.newWordList[i-6]);
                }
                if(19<i && i<(state.newWordList.length+20)){
                    practiseWordList.push(state.newWordList[i-20]);
                }
            }
        }
        return practiseWordList;
        // state.newWordList
    },
    //由切换开关决定当前是背词还是默词list
    currentCardList(state,getters){
        return state.wordListSwitch ? state.newWordList:getters.practiseWordList

    },

    currentCardWord(state,getters){
        // alert(this.$store.getters.currentCardList[index].word);
        // return getters.currentCardList[state.currentCardItemIndex].word;
    },
    isautoplay(state,getters){
        let aaa=false;
        if (state.info.autoplay==1){
            aaa=true;
        }
        return aaa;
    },
    //由当前的单词来生产音频路径
    currentAudioSrc(state){
        let aaa;
        if (state.isUk){
            aaa="uk/";
        }else{
            aaa="us/";
        }
        return 'http://heiline.ltd/ademo/word_audio/' + aaa + state.currentCardItemWord+'.mp3'
    },
    //用来判断控制显示界面组件的多选框里是否有值，避免重复添加，这是个判断数组是否存在某值的方法，以后可套用
    isShow(state){
        return function (name) {
            let isShowTrue = false;
            for(let i=0; i <state.showModuleList.length;i++){
                if (name==state.showModuleList[i]){
                    isShowTrue = true;
                }
            }
            return isShowTrue;
        }
    }
}